import styled from 'styled-components';

import theme from '../../theme';

export const PdfContainerStyled = styled.div`
  margin-top: 18px;
  background-color: ${theme.colors.white};
  padding: 30px 20px;

  @media (max-width: ${theme.breakpoints.md}) {
    background-color: ${theme.colors.lighterBackground};
  }

  & .table-container {
    margin-bottom: 20px;
  }
`;
